import { RichText } from 'prismic-reactjs';
import { IMobileAppBanner } from './types';
import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';
import { RoutesEnum } from '@monofront/types';
import useLocalizedRoutes from '@hooks/i18n/useLocalizedRoutes';
import withSlice from '@screens/SlicesContainer/withSlice';
import { mapMobileAppBanner } from './mapMobileAppBanner';

const MobileAppBanner: React.FC<IMobileAppBanner> = ({
  desktopText,
  image,
  image2,
}) => {
  const { getUrl } = useLocalizedRoutes();

  return (
    <div className="container">
      <ResponsiveImage
        className="left-image"
        alt={image.alt as string}
        src={image.url as string}
        width={200}
        height={200}
      />
      <div className="text">
        <RichText render={desktopText} />
      </div>
      <div className="qr-code">
        <ResponsiveImage
          alt="payment-method"
          src="/images/app-mobile/laf-qrcode.png"
          width={150}
          height={150}
        />
      </div>
      <div className="badges">
        <div>
          <a
            href={getUrl(RoutesEnum.APP_STORE_URL)}
            target="_blank"
            rel="noreferrer"
          >
            <ResponsiveImage
              alt="apple store badge"
              src="/images/app-mobile/badge-apple-store.png"
              width={150}
              height={45}
            />
          </a>
        </div>
        <div>
          <a
            href={getUrl(RoutesEnum.PLAY_STORE_URL)}
            target="_blank"
            rel="noreferrer"
          >
            <ResponsiveImage
              alt="play store badge"
              src="/images/app-mobile/badge-play-store.png"
              width={150}
              height={45}
            />
          </a>
        </div>
      </div>
      <div className="right-image desktop-only">
        <ResponsiveImage
          alt={image2.alt as string}
          src={image2.url as string}
          width={150}
          height={150}
        />
      </div>
      <style jsx>{`
        .container {
          display: flex;
          flex-direction: row;
          align-items: center;
          text-align: center;
          justify-content: space-between;
          background-color: var(--clr-tertiary-2);
          border-radius: var(--rd-4);
          padding: var(--space-2) var(--space-2) var(--space-2) 0;
          height: 200px;
        }

        .container :global(h1) {
          font-size: var(--font-size-4);
          padding: var(--space-4);
        }

        .badges {
          padding: var(--space-4);
        }

        .right-image {
          margin-right: var(--space-2);
        }

        @media (max-width: 1000px) {
          .container :global(h1) {
            font-size: var(--font-size-3);
            padding: var(--space-2);
          }

          .badges {
            padding: var(--space-2);
          }
        }
      `}</style>
    </div>
  );
};

export default withSlice(MobileAppBanner, mapMobileAppBanner);
